import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Button } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { AccessibleFileInputWrapper } from './AccessibleFileInputWrapperSunrise';

type Props = {
	disabled?: boolean;
	onButtonClick?: () => void;
	uppy: Uppy<Meta, Body>;
	fileInputId?: string;
};
export const ImageUploader: React.FC<Props> = ({
	disabled = false,
	onButtonClick,
	uppy,
	fileInputId = 'file-input-id',
}) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const DEFAULT_MEDIA_UPLOAD_IMAGE = getStaticAssetUrl('/images/image-placeholder-drop.svg');
	const { translate } = useI18n();
	const uploadAPhotoText = { strings: { chooseFiles: translate('corgi.sap.button.upload') } };

	return (
		<div className="image-uploader aspect-video">
			<div className="border-stroke-strong h-full rounded-lg border border-dashed">
				<div className="media-upload-content-wrapper flex h-full flex-col items-center justify-center">
					<div className="mt-16 mb-8 hidden leading-[0] md:block">
						<img
							data-testid="drop-target"
							src={DEFAULT_MEDIA_UPLOAD_IMAGE}
							width="115"
							alt={translate('corgi.sap.media.a11y.uploader.image_alt_text')}
						/>
					</div>
					<div className="mb-16" id="sap-media-view">
						<span className="sr-only">
							<Translate value="corgi.sap.media.a11y.uploader.accessible_hidden_div" />
						</span>
						{!disabled ? (
							<AccessibleFileInputWrapper
								uploadButtonText={uploadAPhotoText.strings.chooseFiles}
								uppy={uppy}
								fileInputId={fileInputId}
								onButtonClick={onButtonClick}
							/>
						) : (
							<Button disabled={disabled} variant="primary" data-qa="media-images-upload">
								{uploadAPhotoText.strings.chooseFiles}
							</Button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

ImageUploader.displayName = 'ImageUploader';
